export default "__VITE_ASSET__BzN8vGyX__"